// /* 
// 	NewsletterBanner component is used to newsletter learn more section
// */

import Link from "next/link";
import Button from "../Button/Button";
import styles from './NewsletterBanner.module.css';

export const NewsletterBanner = () => {
  return (
    <section className={styles.newsletterBannerSection}>
      <div className={styles.newsletterBanner}>
        <p>
          Join our community.
          <br />
          Great stories. Great deals. Weekly.
        </p>
        {/* <Link href="/newsletters"><a className="learn-more">Learn More</a></Link> */}
        <Link href="/newsletters-2">
          <Button classes={styles.learnMore} text="Subscribe" />
        </Link>
      </div>
    </section>
  );
};

NewsletterBanner.propTypes = {};

export default NewsletterBanner;
